import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Dialog from "../dialogs/Dialog";
import Input from "../../b-molecules/formElements/input/Input";
import { onValue, ref } from "firebase/database";
import { db } from "../../../configs/Firebase";
import Fuse from "fuse.js";
import style from "./ManageLabels.module.css";
import Icon from "../../a-atoms/icons/Icon";
import Button from "../../b-molecules/buttons/Button";

const ManageLabels = (props) => {
  const org = useSelector((state) => state.orgStatus.value);
  const [labels, setLabels] = useState();
  const [creatingNew, setCreatingNew] = useState(false);
  const [newColor, setNewColor] = useState("#67a7a4");

  useEffect(() => {
    if (org.payload && org.payload !== undefined) {
      const labelsRef = ref(db, "userData/" + org.payload + "/labels");

      onValue(labelsRef, (snapshot) => {
        let data = snapshot.val();
        let temp = [];
        for (let i in data) {
          temp.push({
            id: i,
            ...data[i],
          });
        }
        setLabels(temp);
      });
    }
  }, [org]);

  const fuse = new Fuse(labels, {
    keys: [{ name: "value" }],
    includeMatches: true,
  });
  const [labelResults, setLabelResults] = useState([]);

  const [searchTerm, setSearchTerm] = useState();
  function searchHandler(e) {
    setError("");
    if (e.target.value) {
      setLabelResults(fuse.search(e.target.value));
      setSearchTerm(e.target.value);
    }
  }

  const [error, setError] = useState("");
  function createNew() {
    //does this label already exist?
    if (
      labelResults.some(
        (e) => e.item.value.toUpperCase() === searchTerm.toUpperCase()
      )
    ) {
      setError(
        "This label already exists in the list below.  Click '+' to add it to your journey"
      );
    } else {
      setCreatingNew(true);
    }
  }
  function cancel() {
    setCreatingNew(false);
  }

  const [colorOptions, setColorOptions] = useState([
    { value: "--labelColor1", selected: true },
    { value: "--labelColor2", selected: false },
    { value: "--labelColor3", selected: false },
    { value: "--labelColor4", selected: false },
    { value: "--labelColor5", selected: false },
    { value: "--labelColor6", selected: false },
    { value: "--labelColor7", selected: false },
    { value: "--labelColor8", selected: false },
  ]);

  function setNewColorHandler(index) {
    let tempColorOptions = [...colorOptions];
    for (let i in tempColorOptions) {
      tempColorOptions[i].selected = false;
    }
    tempColorOptions[index].selected = true;
    setNewColor(tempColorOptions[index].value);
    setColorOptions(tempColorOptions);
  }

  return (
    <Dialog show={props.show} onClose={props.onClose} title="Add Label">
      <div className={style.input}>
        <div className={style.colorPicker}></div>
        <Input
          label="Search Labels"
          placeholder=""
          onChange={searchHandler}
          error={error}
        />
      </div>
      {creatingNew ? (
        <div className={style.colourPicker}>
          <ul>
            {colorOptions.map((color, index) => (
              <li
                key={index}
                className={color.selected && style.selected}
                style={{ "--bg": "var(" + color.value + ")" }}
                onClick={() => setNewColorHandler(index)}
              ></li>
            ))}
          </ul>
        </div>
      ) : (
        <ul className={style.searchResults}>
          {labelResults.map((term, index) => (
            <li
              key={index}
              onClick={
                props.currentLabels.some((item) => {
                  return item.value === term.item.value;
                })
                  ? () =>
                      props.onRemoveLabel(
                        props.currentLabels.find((item) => {
                          if (item.value === term.item.value) {
                            return item;
                          }
                        })
                      )
                  : () =>
                      props.onAddLabel(
                        term.item.value,
                        false,
                        term.item.color,
                        term.item.id
                      )
              }
            >
              {term.item.value}{" "}
              {props.currentLabels.some((item) => {
                return item.value === term.item.value;
              }) ? (
                <Icon>remove</Icon>
              ) : (
                <Icon>add</Icon>
              )}
            </li>
          ))}
        </ul>
      )}
      {creatingNew ? (
        <div className={style.actions}>
          <Button variants={["text"]} onClick={cancel}>
            Cancel
          </Button>
          <Button
            variants={["primary"]}
            onClick={() => props.onAddLabel(searchTerm, true, newColor)}
          >
            Save
          </Button>
        </div>
      ) : (
        <div className={style.actions}>
          <Button variants={["text"]} onClick={createNew}>
            Create New
          </Button>
          <Button variants={["text"]} onClick={props.onClose}>
            Close
          </Button>
        </div>
      )}
    </Dialog>
  );
};
export default ManageLabels;
